export default "__VITE_ASSET__QVFxaZ6b__"